/* ss-prodotto.js — si scelgono piu' colori, ognuno coi suoi metri.
   Shopify conta a pezzi interi: un pezzo = mezzo metro. Qui si mostrano i metri
   e si manda al carrello il numero di pezzi. */
(function () {
  var root = document.querySelector('[data-ss-pdp]');
  if (!root) return;

  var perUnit = parseInt(root.getAttribute('data-per-unit'), 10) || 0; /* centesimi per pezzo */
  var passo   = parseFloat(root.getAttribute('data-passo')) || 0.5;   /* metri per pezzo */
  var minM    = parseFloat(root.getAttribute('data-min')) || passo;   /* metri minimi */
  var aPezzo  = root.getAttribute('data-modo') === 'pezzo';
  var minPezzi = aPezzo ? 1 : Math.max(1, Math.round(minM / passo));
  /* Nessun tetto nostro sui tessuti: il massimo e' la giacenza del colore.
     Questo valore serve solo alle varianti senza giacenza tracciata, dove
     Shopify non ci dice quanto ce n'e'. */
  var maxPezzi = aPezzo ? 20 : Math.round(100 / passo);
  /* Sotto questa soglia si dice al cliente quanto ne resta. Sopra, tacere:
     "restano 60 m" non e' un'informazione, e' rumore. */
  var sogliaAvviso = aPezzo ? 5 : Math.round(10 / passo);
  var stage   = document.getElementById('ss-stage-img');
  var sumEl   = root.querySelector('[data-ss-sum]');
  var totEl   = root.querySelector('[data-ss-tot]');
  var cntEl   = root.querySelector('[data-ss-count]');
  var okEl    = root.querySelector('[data-ss-ok]');
  var barra   = document.querySelector('[data-ss-barra]');
  var bSum    = barra && barra.querySelector('[data-barra-sum]');
  var bTot    = barra && barra.querySelector('[data-barra-tot]');
  var bAdd    = barra && barra.querySelector('[data-barra-add]');
  if (barra && barra.parentNode !== document.body) document.body.appendChild(barra);
  var qBox    = root.querySelector('[data-ss-quanto]');
  var qThumb  = root.querySelector('[data-q-thumb]');
  var qName   = root.querySelector('[data-q-name]');
  var qM      = root.querySelector('[data-q-m]');
  var qE      = root.querySelector('[data-q-e]');
  var qRange  = root.querySelector('[data-q-range]');
  var attivo  = null;

  /* Shopify conta pezzi interi, il cliente ragiona in metri. La proprieta porta
     tutti e due i numeri, cosi al pagamento il numero accanto alla riga si spiega. */
  /* Shopify rifiuta l'intero ordine se un colore supera le scorte: il selettore
     si deve fermare prima, altrimenti l'errore arriva solo al momento peggiore. */
  var restanti = {};   /* id variante -> pezzi ancora ordinabili, carrello escluso */

  function tetto(id) {
    var r = restanti[id];
    if (r != null) return Math.max(0, Math.min(maxPezzi, r));
    return maxPezzi;
  }

  /* Shopify non toglie dalla giacenza quello che sta gia nel carrello: lo faccio
     qui, altrimenti il colore resta cliccabile e l'errore arriva solo al momento
     di pagare. */
  function aggiornaScorte(c) {
    var dentro = {};
    (c && c.items || []).forEach(function (it) {
      dentro[it.id] = (dentro[it.id] || 0) + it.quantity;
    });
    root.querySelectorAll('.ss-sw').forEach(function (sw) {
      var id = sw.getAttribute('data-ss-var');
      var st = sw.getAttribute('data-stock');
      if (st === null) { delete restanti[id]; return; }
      var resta = parseInt(st, 10) - (dentro[id] || 0);
      restanti[id] = resta;
      var esaurito = resta < 1;
      sw.classList.toggle('is-off', esaurito);
      if (esaurito) {
        sw.setAttribute('data-off', '');
        sw.setAttribute('aria-disabled', 'true');
        sw.setAttribute('tabindex', '-1');
        sw.title = sw.getAttribute('data-name') + ' — non ne resta';
        if (presi[id]) delete presi[id];
      } else if (sw.hasAttribute('data-off') && parseInt(st, 10) > 0) {
        sw.removeAttribute('data-off');
        sw.removeAttribute('aria-disabled');
        sw.setAttribute('tabindex', '0');
        sw.title = sw.getAttribute('data-name');
      }
    });
    if (typeof disegnaPresi === 'function') disegnaPresi();
  }

  fetch('/cart.js').then(function (r) { return r.json(); }).then(aggiornaScorte).catch(function () {});
  document.addEventListener('ss:carrello', function (e) {
    /* il carrello puo cambiare dal cassetto: qui il riepilogo si rifa da quello
       che c'e davvero, altrimenti resta a mostrare colori tolti da un pezzo */
    if (typeof rileggiPresi === 'function') rileggiPresi(e.detail);
    aggiornaScorte(e.detail);
  });

  function etichettaTaglio(pezzi) {
    return soloNum(pezzi) + ' m (' + pezzi + ' \u00d7 ' + Math.round(passo * 100) + ' cm)';
  }

  /* La barra in basso dice cosa hai gia preso e porta al carrello: il pulsante
     che aggiunge vive dentro il foglio del taglio, non qui. */
  var prev = null; /* colore in anteprima, non ancora scelto */
  var pBox   = root.querySelector('[data-ss-prev]');
  var pThumb = root.querySelector('[data-prev-thumb]');
  var pName  = root.querySelector('[data-prev-name]');
  var pPrice = root.querySelector('[data-prev-price]');
  var pAdd   = root.querySelector('[data-prev-add]');
  var unitTxt = root.getAttribute('data-modo') === 'pezzo' ? 'al pezzo' : 'al metro';

  function eur(cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; }
  function soloNum(pezzi) {
    if (aPezzo) return String(pezzi);
    var m = pezzi * passo;
    return (passo < 0.5 ? m.toFixed(2) : m.toFixed(1)).replace('.', ',');
  }
  function metri(pezzi) {
    return aPezzo ? (pezzi + (pezzi === 1 ? ' pezzo' : ' pezzi')) : soloNum(pezzi) + ' m';
  }
  var UN = aPezzo ? 'pz' : 'm';

  function icona(seg) {
    /* apici singoli: queste icone finiscono dentro un attributo style fra virgolette doppie */
    return "url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 " +
           "fill=%22%231E2224%22%3E" + seg + "%3C/svg%3E')";
  }
  var MENO = icona('%3Crect x=%224%22 y=%2211%22 width=%2216%22 height=%222.4%22 rx=%221.2%22/%3E');
  var PIU  = icona('%3Crect x=%224%22 y=%2211%22 width=%2216%22 height=%222.4%22 rx=%221.2%22/%3E%3Crect x=%2210.8%22 y=%224%22 width=%222.4%22 height=%2216%22 rx=%221.2%22/%3E');
  var qGiu = root.querySelector('[data-q-giu]'), qSu = root.querySelector('[data-q-su]');
  if (qGiu) qGiu.style.backgroundImage = MENO;
  if (qSu)  qSu.style.backgroundImage  = PIU;

  /* ---------------------------------------------------------------
     Il percorso: scegli il colore, ti si apre il foglio dei metri,
     aggiungi, il foglio si chiude e i colori sono di nuovo davanti.
     Una domanda per volta. Nessun riquadro che scorre dentro la pagina.
     --------------------------------------------------------------- */

  var presi = {};                 /* id -> {n, img, prezzo, pezzi} gia nel carrello da qui */
  var fg     = document.querySelector('[data-ss-foglio]');
  var fgImg  = fg && fg.querySelector('[data-fg-img]');
  var fgNome = fg && fg.querySelector('[data-fg-nome]');
  var fgPrz  = fg && fg.querySelector('[data-fg-prezzo]');
  var fgDom  = fg && fg.querySelector('[data-fg-dom]');
  var fgVal  = fg && fg.querySelector('[data-fg-val]');
  var fgUn   = fg && fg.querySelector('[data-fg-un]');
  var fgGiu  = fg && fg.querySelector('[data-fg-giu]');
  var fgSu   = fg && fg.querySelector('[data-fg-su]');
  var fgTape = fg && fg.querySelector('[data-fg-tape]');
  var fgFill = fg && fg.querySelector('[data-fg-fill]');
  var fgRange= fg && fg.querySelector('[data-fg-range]');
  var fgResta= fg && fg.querySelector('[data-fg-resta]');
  var fgAdd  = fg && fg.querySelector('[data-fg-add]');
  var fgTot  = fg && fg.querySelector('[data-fg-tot]');
  var griglia = root.querySelector('[data-ss-grid]');
  var tutti   = root.querySelector('[data-ss-tutti]');
  var presiBox = root.querySelector('[data-ss-presi]');
  var presiLista = root.querySelector('[data-ss-presi-lista]');
  if (fg && fg.parentNode !== document.body) document.body.appendChild(fg);
  if (fgGiu) fgGiu.style.backgroundImage = MENO;
  if (fgSu)  fgSu.style.backgroundImage  = PIU;

  var apertoSu = null;            /* colore aperto nel foglio */
  var quanti = 0;                 /* pezzi scelti nel foglio */

  function tasto(el, fn) {
    if (!el) return;
    el.addEventListener('click', fn);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(); }
    });
  }

  /* ---- la griglia dei colori: pochi in vista, il resto dietro un pulsante ---- */

  var quantiInVista = parseInt(root.getAttribute('data-quanti'), 10) || 12;
  var swAll = [].slice.call(griglia.querySelectorAll('.ss-sw'));
  var aperta = false;

  function regolaGriglia() {
    if (!tutti) return;
    if (swAll.length <= quantiInVista) { tutti.hidden = true; return; }
    tutti.hidden = false;
    swAll.forEach(function (sw, i) {
      /* un colore gia preso resta sempre visibile, anche a griglia chiusa */
      var idsw = sw.getAttribute('data-ss-var');
      sw.hidden = !aperta && i >= quantiInVista && !presi[idsw];
    });
    tutti.textContent = aperta ? 'Mostra meno colori' : 'Vedi tutti i ' + swAll.length + ' colori';
    tutti.classList.toggle('is-aperta', aperta);
  }
  tasto(tutti, function () {
    /* chiudendo, la pagina si accorcia e ti ritrovi altrove: tengo il pulsante
       fermo dov'e, spostando lo scorrimento di quanto e cambiata l'altezza */
    var prima = tutti.getBoundingClientRect().top;
    aperta = !aperta;
    regolaGriglia();
    var dopo = tutti.getBoundingClientRect().top;
    if (Math.abs(dopo - prima) > 1) window.scrollBy(0, dopo - prima);
  });
  regolaGriglia();

  /* ---- il foglio ---- */

  function apriFoglio(sw) {
    var id = sw.getAttribute('data-ss-var');
    if (sw.hasAttribute('data-off')) return;
    var t = tetto(id);
    if (t < 1) return;

    apertoSu = {
      id: id,
      n: sw.getAttribute('data-name'),
      img: sw.getAttribute('data-img'),
      prezzo: parseInt(sw.getAttribute('data-price'), 10) || perUnit
    };
    var big = sw.getAttribute('data-big') || sw.getAttribute('data-img');
    if (stage && big) { stage.src = big; if (stage.srcset) stage.srcset = ''; }

    quanti = presi[id] ? presi[id].pezzi : Math.min(minPezzi, t);
    fgImg.innerHTML = apertoSu.img ? '<img src="' + apertoSu.img + '" alt="">' : '';
    fgNome.textContent = apertoSu.n;
    var alPezzo = aPezzo ? apertoSu.prezzo : Math.round(apertoSu.prezzo / passo);
    fgPrz.textContent = eur(alPezzo) + (aPezzo ? ' al pezzo' : ' al metro');
    fgDom.textContent = aPezzo
      ? 'Quanti ne vuoi?'
      : 'Quanti metri di ' + apertoSu.n.toLowerCase() + '?';
    fgUn.textContent = UN;
    fgRange.min = 1;
    fgRange.max = Math.max(1, t);
    fgTape.style.setProperty('--tick', (100 / Math.max(1, t)).toFixed(3) + '%');
    scriviFoglio();

    fg.hidden = false;
    document.documentElement.classList.add('ss-foglio-aperto');
    setTimeout(function () { fgAdd.focus(); }, 80);
  }

  function chiudiFoglio() {
    if (!fg) return;
    fg.hidden = true;
    document.documentElement.classList.remove('ss-foglio-aperto');
    apertoSu = null;
  }

  function scriviFoglio() {
    if (!apertoSu) return;
    var t = tetto(apertoSu.id);
    if (quanti > t) quanti = t;
    if (quanti < 1) quanti = 1;
    fgVal.textContent = soloNum(quanti);
    fgRange.value = quanti;
    if (fgFill) fgFill.style.setProperty('--p', (quanti - 1) / Math.max(1, t - 1));
    fgTot.textContent = eur(quanti * apertoSu.prezzo) + ' in tutto';
    var mostraResta = t <= sogliaAvviso;
    fgResta.hidden = !mostraResta;
    if (mostraResta) {
      fgResta.textContent = 'Di questo colore restano ' +
        (aPezzo ? t + (t === 1 ? ' pezzo' : ' pezzi') : soloNum(t) + ' m') + '.';
    }
    var gia = presi[apertoSu.id];
    fgAdd.querySelector('.ss-add__box').textContent = gia ? 'Aggiorna il taglio' : 'Aggiungi al carrello';
  }

  function muovi(d) {
    if (!apertoSu) return;
    var t = tetto(apertoSu.id);
    var n = quanti + d;
    if (n < minPezzi) n = minPezzi;
    if (n > t) n = t;
    quanti = n;
    scriviFoglio();
  }
  tasto(fgSu, function () { muovi(1); });
  tasto(fgGiu, function () { muovi(-1); });
  if (fgRange) fgRange.addEventListener('input', function (e) {
    quanti = Math.max(minPezzi, parseInt(e.target.value, 10) || minPezzi);
    scriviFoglio();
  });
  fg && fg.querySelectorAll('[data-fg-chiudi]').forEach(function (x) {
    x.addEventListener('click', chiudiFoglio);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && fg && !fg.hidden) chiudiFoglio();
  });

  /* ---- l'aggiunta, un colore per volta ---- */

  fgAdd.addEventListener('click', function () {
    if (!apertoSu) return;
    var scelto = apertoSu, n = quanti;
    var riga = { id: Number(scelto.id), quantity: n };
    if (!aPezzo) riga.properties = { 'Taglio': etichettaTaglio(n) };

    fgAdd.disabled = true;
    fgAdd.querySelector('.ss-add__box').textContent = 'Un attimo…';

    /* se quel colore c'era gia, questa e una correzione: prima lo tolgo */
    var prima = presi[scelto.id]
      ? fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(scelto.id), quantity: 0 })
        })
      : Promise.resolve();

    prima.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [riga] })
      });
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) {
        throw new Error((d && (d.description || d.message)) || 'carrello');
      }, function () { throw new Error('carrello'); });
      return r.json();
    }).then(function () {
      fgAdd.disabled = false;
      chiudiFoglio();
      okEl.innerHTML = '<b>' + scelto.n + '</b>, ' + soloNum(n) + ' ' + UN + ' nel carrello. Scegli un altro colore.';
      okEl.classList.add('is-on');
      /* niente cassetto che si apre: qui la gente sta ancora scegliendo */
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (c) {
      if (!c) return;
      var b = document.querySelector('[data-ss-count-cart]');
      if (b) b.textContent = c.item_count;
      rileggiPresi(c);
      aggiornaScorte(c);
    }).catch(function (e) {
      var m = e && e.message && e.message !== 'carrello' ? e.message : '';
      fgAdd.disabled = false;
      scriviFoglio();
      okEl.textContent = m
        ? m + ' Cambia la quantità e riprova.'
        : 'Non è riuscito. Riprova, oppure scrivici su WhatsApp.';
      okEl.classList.add('is-on');
    });
  });

  /* ---- il riepilogo di quello che si e preso da questa pagina ---- */

  function disegnaPresi() {
    var ids = Object.keys(presi);
    presiBox.hidden = ids.length === 0;
    presiLista.innerHTML = '';
    var cent = 0;
    ids.forEach(function (id) {
      var s = presi[id];
      cent += s.pezzi * s.prezzo;
      var li = document.createElement('li');
      li.innerHTML = '<b>' + s.n + '</b> ' + soloNum(s.pezzi) + ' ' + UN + ' <i>' + eur(s.pezzi * s.prezzo) + '</i>';
      presiLista.appendChild(li);
    });
    /* il colore preso resta segnato nella griglia */
    root.querySelectorAll('.ss-sw').forEach(function (sw) {
      var id = sw.getAttribute('data-ss-var');
      var q = sw.querySelector('[data-ss-q]');
      sw.classList.toggle('is-on', !!presi[id]);
      sw.setAttribute('aria-pressed', presi[id] ? 'true' : 'false');
      if (q) q.textContent = presi[id] ? soloNum(presi[id].pezzi) : '';
    });
    if (cntEl) cntEl.textContent = ids.length
      ? ids.length + (ids.length === 1 ? ' colore preso' : ' colori presi')
      : '';
    regolaGriglia();
    if (barra) {
      barra.hidden = ids.length === 0;
      document.documentElement.classList.toggle('ss-barra-su', ids.length > 0);
      if (bSum) bSum.textContent = ids.length + (ids.length === 1 ? ' colore nel carrello' : ' colori nel carrello');
      if (bTot) bTot.textContent = eur(cent);
      if (bAdd) bAdd.textContent = 'Vai al carrello';
    }
  }

  root.querySelectorAll('.ss-sw').forEach(function (sw) {
    sw.addEventListener('click', function () { apriFoglio(sw); });
    sw.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sw.click(); }
    });
  });

  if (bAdd) bAdd.addEventListener('click', function () { location.href = '/cart'; });


  /* miniature della galleria */
  var gal = root.querySelector('[data-ss-gal]');
  if (gal) gal.querySelectorAll('.ss-gal__i').forEach(function (g) {
    function vai() {
      var b = g.getAttribute('data-gal-big');
      if (stage && b) { stage.src = b; if (stage.srcset) stage.srcset = ''; }
      gal.querySelectorAll('.is-on').forEach(function (e) { e.classList.remove('is-on'); });
      g.classList.add('is-on');
    }
    g.addEventListener('click', vai);
    g.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); vai(); }
    });
  });


  /* Il riepilogo non tiene una memoria sua: lo ricostruisco dal carrello vero,
     all'apertura e ogni volta che il carrello cambia. Se lo svuoti, sparisce. */
  function rileggiPresi(c) {
    presi = {};
    (c && c.items || []).forEach(function (it) {
      var sw = root.querySelector('.ss-sw[data-ss-var="' + it.id + '"]');
      if (!sw) return;
      presi[it.id] = {
        n: sw.getAttribute('data-name'),
        img: sw.getAttribute('data-img'),
        prezzo: parseInt(sw.getAttribute('data-price'), 10) || perUnit,
        pezzi: it.quantity
      };
    });
    disegnaPresi();
  }

  fetch('/cart.js').then(function (r) { return r.json(); })
    .then(rileggiPresi).catch(function () { disegnaPresi(); });
})();
